"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const ButtonWeb = ({ children, type, fullWidth = false, isDisabled = false, style = {}, onClick, className = "" }) => {
    let colorClass;
    switch (type) {
        case "Blue":
            colorClass = "button-blue";
            break;
        case "White-BlueFont":
            colorClass = "button-white-blue-font";
            break;
        case "White":
            colorClass = "button-white";
            break;
        case "Red":
            colorClass = "button-red";
            break;
        case "White-RedFont":
            colorClass = "button-white-red-font";
            break;
    }
    if (fullWidth) {
        style.width = '100%';
    }
    return ((0, jsx_runtime_1.jsx)("button", { onClick: onClick, className: colorClass + " " + className, style: style, disabled: isDisabled, children: children }));
};
exports.default = ButtonWeb;
